import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import notificationService from "../../../services/notificationService";
import { useWebNotificationContext } from "../../../contexts/WebNotificationContext";
import { formatInTimeZone } from 'date-fns-tz';

const NotificationDetail = ({ userId }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();


  const { fetchNotificationById, markAsRead } = notificationService();
  const [notification, setNotification] = useState(null);
  const { refreshUnreadCount } = useWebNotificationContext();

  function formatToLocalDDMMYYYY(utcDateString) {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return formatInTimeZone(utcDateString, userTimeZone, 'dd/MM/yyyy, HH:mm:ss');
  }

  useEffect(() => {
    const load = async () => {
      const data = await fetchNotificationById(id, userId);
      setNotification(data);

      if (!data.isRead) {
        await markAsRead(data.userId, [id]);
        refreshUnreadCount();
        setNotification(prev => ({ ...prev, isRead: true }));
      }
    };
    load();
  }, [id]);

  if (!notification) return <div>Loading...</div>;

  const onBackClick = () => {
    if (location.state?.fromBellIcon) {
      navigate("/home");
    } else if (location.state?.fromNotificationList) {
      navigate("/notifications");
    } else {
      // fallback
      navigate("/home");
    }
  };


  return (
    <div className="max-w-3xl mx-auto mt-10 px-4">
      <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-200">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Notification Detail</h2>

        <div className="space-y-4 text-base text-gray-700">
          <div>
            <p className="text-sm text-gray-500">Message</p>
            <p className="font-medium text-gray-900">{notification.message}</p>
          </div>

          <div>
            <p className="text-sm text-gray-500">Status</p>
            <span className={`inline-block px-3 py-1 rounded-full text-sm font-semibold 
            ${notification.isRead ? "bg-green-100 text-green-800" : "bg-yellow-100 text-yellow-800"}`}>
              {notification.isRead ? "Read" : "Unread"}
            </span>
          </div>

          <div>
            <p className="text-sm text-gray-500">Received At</p>
            <p className="font-medium text-gray-900">{formatToLocalDDMMYYYY(notification.timestamp)}</p>
          </div>
          <div className="pt-4">
            <button
              className="block w-full rounded-md border border-stroke p-3 text-center text-base font-medium text-dark transition hover:border-red-600 hover:bg-red-600 hover:text-white"
              onClick={onBackClick}
            >
              Back
            </button>
          </div>
        </div>
      </div>
    </div>
  )
};


export default NotificationDetail;
